import * as XLSX from 'xlsx';
import type { BrandLedgerPage, CreatorIncome } from '../api/payment/brand-ledger.api';

// Tên sheet và cột theo spec 2026-10-10-brand-tax-compliance §4.4, §5. Dùng aoa_to_sheet để file rỗng vẫn có dòng tiêu đề.
export const LEDGER_SHEET = 'Sổ dòng tiền';
export const LEDGER_TOTALS_SHEET = 'Tổng theo loại';
export const INCOME_SHEET = 'Thu nhập creator';

export const LEDGER_COLUMNS = [
  'Thời điểm (giờ Việt Nam)',
  'Loại',
  'Mã đơn',
  'Mã chiến dịch',
  'Tên chiến dịch',
  'Người đặt',
  'Loại người đặt',
  'Mã số thuế người đặt',
  'Họ tên người đặt theo CCCD',
  'Họ tên creator theo CCCD',
  'Mã số thuế hoặc CCCD của creator',
  'Số tiền (đ)',
  'Số Ca',
  'Ghi chú',
];
export const LEDGER_TOTAL_COLUMNS = ['Loại', 'Số tiền (đ)', 'Số Ca'];
export const INCOME_COLUMNS = [
  'Họ tên theo CCCD',
  'Tên hiển thị',
  'Mã số thuế hoặc CCCD',
  'Tổng giá trị (đ)',
  'Phí sàn (đ)',
  'Thực nhận (đ)',
  'Số đơn',
  'Bồi thường (đ)',
];

export const ledgerFileName = (from: string, to: string) => `so-dong-tien-san-hop-tac_${from}_${to}.xlsx`;

export const incomeFileName = (year: number, month?: number | null) =>
  month ? `thu-nhap-creator_${year}_${String(month).padStart(2, '0')}.xlsx` : `thu-nhap-creator_${year}.xlsx`;

export const buildLedgerWorkbook = (data: BrandLedgerPage): XLSX.WorkBook => {
  const wb = XLSX.utils.book_new();
  const items = (data.items ?? []).map((i) => [
    i.atVn,
    i.kind,
    i.dealId ?? '',
    i.campaignId ?? '',
    i.campaignTitle ?? '',
    i.ordererName,
    i.ordererKind,
    i.ordererTaxCode ?? '',
    i.ordererIdentityName ?? '',
    i.creatorIdentityName ?? '',
    i.creatorTaxOrId ?? '',
    i.amountVnd,
    i.amountCa ?? '',
    i.note ?? '',
  ]);
  XLSX.utils.book_append_sheet(wb, XLSX.utils.aoa_to_sheet([LEDGER_COLUMNS, ...items]), LEDGER_SHEET);
  const totals = (data.totals ?? []).map((t) => [t.kind, t.amountVnd, t.amountCa]);
  XLSX.utils.book_append_sheet(wb, XLSX.utils.aoa_to_sheet([LEDGER_TOTAL_COLUMNS, ...totals]), LEDGER_TOTALS_SHEET);
  return wb;
};

export const buildIncomeWorkbook = (data: CreatorIncome): XLSX.WorkBook => {
  const wb = XLSX.utils.book_new();
  const items = (data.items ?? []).map((i) => [
    i.identityName ?? '',
    i.displayName,
    i.taxOrId ?? '',
    i.grossVnd,
    i.feeVnd,
    i.netVnd,
    i.dealCount,
    i.compensationVnd,
  ]);
  XLSX.utils.book_append_sheet(wb, XLSX.utils.aoa_to_sheet([INCOME_COLUMNS, ...items]), INCOME_SHEET);
  return wb;
};

export const downloadWorkbook = (wb: XLSX.WorkBook, fileName: string) => XLSX.writeFile(wb, fileName);
